export const hrDashboardHiringProcessApi = {
    heading:[
        {
            head:"Full Name"
        },
        {
            head:"Position"
        },
        {
            head:"Status"
        },
        {
            head:"Action"
        },
       
    ],
    data:[
       {
            fullname:"Asequl Arefin",
            position:"Lecturer",
            status:"Task",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
     
       },
       {
            fullname:"Jamilur Arefin",
            position:"Lecturer",
            status:"Tech Interview",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
       },
       {
            fullname:"Asequl Arefin",
            position:"Lecturer",
            status:"Final Interview",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
       },
       {
            fullname:"Asequl Arefin",
            position:"Lecturer",
            status:"Resume Review",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
       },
       {
            fullname:"Asequl Arefin",
            position:"Lecturer",
            status:"Task",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
       },
       {
            fullname:"Jamilur Arefin",
            position:"Lecturer",
            status:"Tech Interview",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
       },
       {
            fullname:"Asequl Arefin",
            position:"Lecturer",
            status:"Final Interview",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
       },
       {
            fullname:"Asequl Arefin",
            position:"Lecturer",
            status:"Resume Review",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
       },
       {
            fullname:"Asequl Arefin",
            position:"Lecturer",
            status:"Task",
            action:""
       },
       {
            fullname:"Jamilur Arefin",
            position:"Lecturer",
            status:"Tech Interview",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
       },
       
    ]
    }